<template>
  <div class="redirect-to-open-banking-popup" :class="{ loading }">
    <popup :buttons="buttons" :close-action="closeModal">
      <template v-slot:title>
        <img class="logo-image" :src="require(`@/assets/bank-logos/${source.openBanking.redirectPopup.file}`)">
        <div class="popup-title">{{ title }}</div>
      </template>
      <template v-slot:content>
        <div>
          <div class="description">
            <span>חיבור דרך {{ source.displayName }} יתן ל-RiseUp     </span>
            <span class="bold">הרשאה לקריאה בלבד</span>
            <span>של הנתונים ובתוקף לשנה.   </span>
          </div>
          <div class="description partners" v-if="source.openBanking.jointAccountSupported">
            <div class="bold">יש לך חשבון עם שותפ.ה? </div>
            <div>צריך לוודא שזיהוי המשתמש מול הבנק מתאים לתעודת הזהות שהכנסת לפני רגע.</div>
          </div>
        </div>
        <div>
          <div v-if="source.openBanking.redirectPopup.backText" class="description">
            <span>בסיום חיבור מוצלח ב{{ source.displayName }},</span>
            <span class="bold"> תועברו אוטומטית חזרה לרייזאפ. </span>
            <span>אם מסיבה כלשהי לא הועברתם, מומלץ לחזור לרייזאפ ולהתחיל שוב את תהליך חיבור {{ source.displayName }}. </span>
          </div>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DDLogs from '@/DDLogs';
import consts from '@/constants/onboarding-state';
import BaseUI from 'base-ui';
import Segment from '../../../Segment';
import AggregatorApi from '../../../api/AggregatorApi';
import onboardingApi from '../../../api/OnbordingApi';

export default {
  name: 'RedirectToOpenBankingPopup',
  props: {
    idNumber: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    source: {
      type: Object,
      required: true,
    },
  },
  async created() {
    Segment.trackUserGot('RedirectToOBKPopup', { idNumber: this.idNumber, source: this.source.name });
  },
  data() {
    return {
      loading: false,
    };
  },
  components: {
    Popup: BaseUI.Popup,
  },
  computed: {
    ...mapState('onboardingState', ['pageName']),
    title() {
      return this.source.openBanking.redirectPopup.title;
    },
    isOnboarding() {
      return this.pageName && this.pageName !== consts.ONBOARDING_PAGE.CASHFLOW;
    },
    displayName() {
      return this.source.displayName;
    },
    buttons() {
      return [
        {
          title: this.source.openBanking.redirectPopup.buttonTitle,
          variant: 'primary',
          action: this.redirectToGetAccessCode,
          loading: this.loading,
          size: 'slim',
        },
      ];
    },
  },
  methods: {
    closeModal() {
      Segment.trackUserInteraction('RedirectToOpenBankingPopup_CloseClicked', { idNumber: this.idNumber, source: this.source.name });
      this.$emit('close');
    },
    async redirectToGetAccessCode() {
      this.loading = true;
      Segment.trackUserInteraction('RedirectToOBKPopup_ContinueInOBKClicked', { idNumber: this.idNumber, source: this.source.name });
      try {
        const redirectUrl = await AggregatorApi.createConsent(this.idNumber, this.source.openBanking.aggregatorBankId, this.name);
        if (this.isOnboarding) {
          try {
            await onboardingApi.bankDetailsSubmitOpenBankingCreateConsent(redirectUrl, this.source.sourceName);
          } catch (error) {
            DDLogs.error('Failed updating OpenBanking redirectUrl in johnny', { error });
          }
        }
        this.loading = false;
        this.$emit('close');
        window.location.href = redirectUrl;
      } catch (error) {
        Segment.trackUserGot('OBKConsentCreationError', { idNumber: this.idNumber, source: this.source.name });
        DDLogs.error('Failed getting redirect url from open-banking', { error });
        this.$emit('close');
      }
    },
  },
};
</script>

<style lang="scss" scoped>

  .redirect-to-open-banking-popup {

    &.loading{
      opacity: 0.5;
      pointer-events: none;
    }

    .popup-title {
      font-family: SimplerPro;
      font-weight: bold;
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 27px;
    }

    .logo-image {
      height: 40px;
      margin-bottom: 20px;
    }

    .description {
      font-family: SimplerPro;
      margin-bottom: 27px;
      font-size: 16px;
      line-height: 22px;

      .bold {
        font-weight: bold;
      }
    }
    .description.partners { margin-bottom: 60px; }

  }
</style>
